type TagNamePlanTypes = {
  bonus: string;
  franchise: string;
};
export const tagNamePlan = ({ bonus, franchise }: TagNamePlanTypes) => {
  const totalGbPlan = Number(bonus) + Number(franchise);
  const tagNamePlan = `${totalGbPlan}GB`;
  return tagNamePlan;
};
